import underscore from 'underscore';

const formatDataForCSA = (data, type) => {
  if (data) {
    var datalist = underscore.find(data, function (v) {
      return v.type === type;
    });
    return datalist && datalist.values;
  } else return [];
};

const avgForCSA = (data, type) => {
  if (data) {
    var datalist = underscore.find(data, function (v) {
      return v.type === type;
    });
    return datalist && datalist.average;
  } else return '';
};

const labelFinder = (label, data, filter) => {
  let avg = avgForCSA(data, filter);

  if (avg) return `${label}(Avg: ${avg})`;
  else return label;
};

export const getDataSets = ({ csasnapshot, crashSummaryChart }) => {
  const { series } = csasnapshot?.basicMeasures || {};

  return {
    datasets1: [
      {
        data: formatDataForCSA(series, 'HOS'),
        label: labelFinder('HOS', series, 'HOS'),
        backgroundColor: 'rgba(50, 125, 255, 0.2)',
        borderColor: '#224f9c',
        average: avgForCSA(series, 'HOS'),
      },
      {
        data: formatDataForCSA(series, 'Vehicle Maintenance'),
        label: labelFinder('VM', series, 'Vehicle Maintenance'),
        backgroundColor: 'rgba(245, 166, 35, 0.2)',
        borderColor: '#f5a623',
        average: avgForCSA(series, 'Vehicle Maintenance'),
      },
      {
        data: formatDataForCSA(series, 'HM'),
        label: labelFinder('HM', series, 'HM'),
        backgroundColor: 'rgba(229, 51, 145, 0.2)',
        borderColor: '#a32668',
        average: avgForCSA(series, 'HM'),
      },
    ],
    datasets2: [
      {
        data: formatDataForCSA(series, 'Unsafe Driving'),
        label: labelFinder('UD', series, 'Unsafe Driving'),
        borderColor: '#ec2d2d',
        backgroundColor: 'rgba(236, 45, 45, 0.2)',
        average: avgForCSA(series, 'Unsafe Driving'),
      },
      {
        data: formatDataForCSA(series, 'Driver Fitness'),
        label: labelFinder('DF', series, 'Driver Fitness'),
        borderColor: '#f5a623',
        backgroundColor: 'rgba(245, 166, 35, 0.2)',
        average: avgForCSA(series, 'Driver Fitness'),
      },
      {
        data: formatDataForCSA(series, 'cs'),
        label: labelFinder('CS', series, 'cs'),
        borderColor: '#224f9c',
        backgroundColor: 'rgba(114, 111, 246, 0.2)',
        average: avgForCSA(series, 'cs'),
      },
      {
        data: formatDataForCSA(series, 'Crash '),
        label: labelFinder('Crash', series, 'Crash '),
        borderColor: '#158f43',
        backgroundColor: 'rgba(53, 195, 106, 0.2)',
        average: avgForCSA(series, 'Crash '),
      },
    ],
    datasets3: [
      {
        label: 'DOT Recordable',
        backgroundColor: '#1812b9',
        data: crashSummaryChart.dot,
      },
      {
        label: 'Tow Away',
        backgroundColor: '#a32668',
        data: crashSummaryChart.tow,
      },
      {
        label: 'Injuries',
        backgroundColor: '#158f43',
        data: crashSummaryChart.injuries,
      },
      {
        label: 'Fatalities',
        backgroundColor: '#f54523',
        data: crashSummaryChart.fatalities,
      },
      {
        label: 'With Citations',
        backgroundColor: '#f5a623',
        data: crashSummaryChart.citations,
      },
    ],
  };
};
